import { render } from "./kalio-accordion-row.vue?vue&type=template&id=74ccd74a"
import script from "./kalio-accordion-row.vue?vue&type=script&lang=js"
export * from "./kalio-accordion-row.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__